import { ErrorHandler } from '@angular/core';
import * as Raven from 'raven-js';
import { environment } from '../environments/environment';



export class RavenErrorHandler implements ErrorHandler {
	constructor() {
		if ('SERVICE_SENTRY_DSN_PUBLIC' in environment) {
			Raven.config((environment as any).SERVICE_SENTRY_DSN_PUBLIC, {
				environment:	environment.APP_ENV,
				release:		environment.COMMIT_HASH.substr(0, 8),
			})
			.install();
		}
	}



	public handleError(err: any): void {
		Raven.captureException(err.originalError);
	}
}

export const SENTRY_PROVIDER = {
	provide:	ErrorHandler,
	useClass:	RavenErrorHandler,
};



// WEBPACK FOOTER //
// ./src/app/app.sentry.ts